import React from "react";
import TagImage from "Atoms/TagImage";
import * as _ from 'lodash';

export const Policies = ({ policies, showAmount }) => {
	let tagConfigObj = {
		home: {count: 0,tag: "Home",fullTag: "Homeowners"},
		auto: {count: 0,tag: "Auto",fullTag: "Automobile"},
		collection: {count: 0,tag: "Collection",fullTag: "Private Collections"},
		earthQuake: {count: 0,tag: "Earth Quake",fullTag: "Earthquake"},
		excessLiability: {count: 0,tag: "Excess",fullTag: "Personal Excess Liability"},
		excessFlood: {count: 0,tag: "Flood",fullTag: "Excess Flood"}
	}

	policies.forEach(policy => {
		switch (policy.policy_type) {
			case "PCGHome":
				tagConfigObj.home.count++;
				break;
			case "PHOME":
				tagConfigObj.home.count++;
				break;
			case "PCGAuto":
				tagConfigObj.auto.count++;
				break;
			case "PAUTO":
				tagConfigObj.auto.count++;
				break;
			case "PCGCollections":
				tagConfigObj.collection.count++;
				break;
			case "PCGExcessLiability":
				tagConfigObj.excessLiability.count++;
				break;
			case "PCGEarthquake":
				tagConfigObj.earthQuake.count++;
				break;
			case "PCGExcessFlood":
				tagConfigObj.excessFlood.count++;
				break;
			default:
				break;
		}
	});
	function withInlineDiv(component) {
		return (
				<div className="tag-item">
					{component}
				</div> )
	}

	function renderPolicyCount() {
		let policiesDivArr = [];
		_.forOwn(tagConfigObj, value => {
			if (value.count !== 0)
				policiesDivArr.push(`${value.fullTag} Policy(s)`);
		});
		let policiesDivString = policiesDivArr.join(', ');
		return (
			<div>{policiesDivString}</div>
		)
	}
	return (
		<div className="row policies">
			<div className="dx-col">
				<div className="label"> Policies </div>
				<div className="content">
					<div className="tags-object">

						<div className="tags-summary">{showAmount ? renderPolicyCount() : null}</div>

						<div className="tags-images">
							{tagConfigObj.home.count > 0 ? withInlineDiv(<TagImage type="home"/>): ""}
							{tagConfigObj.auto.count > 0 ? withInlineDiv(<TagImage type="auto"/>): ""}
							{tagConfigObj.collection.count > 0 ? withInlineDiv(<TagImage type="collection"/>): ""}
							{tagConfigObj.excessFlood.count > 0 ? withInlineDiv(<TagImage type="excessFlood"/>): ""}
							{tagConfigObj.earthQuake.count > 0 ? withInlineDiv(<TagImage type="earthQuake"/>): ""}
							{tagConfigObj.excessLiability.count > 0 ? withInlineDiv(<TagImage type="excessLiability"	/>): ""}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}


// WEBPACK FOOTER //
// ./src/components/atomic/molecules/Policies/Policies.js